<template>
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <ContactForm
        :title="$t('contact:form.first_text')"
        :sub-title="$t('contact:form.second_text')"
      />
    </div>
  </div>
</template>
<script>
import ContactForm from "./ContactForm.vue";
export default {
  components: { ContactForm },
  data() {
    return {};
  }
};
</script>
